import { AdapterInterface } from '@/common/interfaces';
import { TopNavItem } from '@/common/models';

export const topNavAdapter: AdapterInterface<any> = {
    adapt: (data: any) => {
        const arr = Object.values(data);
        return arr.map(
            (item: any): TopNavItem => {
                const { subnav } = item;
                return new TopNavItem({ ...item, subnav: topNavAdapter.adapt(subnav) });
            }
        );
    },
};
